import {format, parse} from "telefone";

export default class String{

    static capitalise(string = ""){

        string = this.toString(string);

        return string.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());

    }

    static telefone(string = ""){

        if(!parse(string, { apenasFixo: true })){
            return "";
        }

        return format(this.stripNumbers(string));

    }

    static celular(string = ""){

        if(!parse(string, { apenasCelular: true })){
            return "";
        }

        return format(this.stripNumbers(string));

    }

    static stripNumbers(string = ""){

        string = this.toString(string);
        string = string.replace(/\D/g, '');

        return string;

    }

    static toString(string = ""){
        return `${string||""}`;
    }

    static greatherThan(string="", value=0){
        return string?.length > value ? true : false
    }

    static greatherOrEqualTo(string="", value=0){
        return string?.length >= value ? true : false
    }

    static lessThan(string = "", value = 0){
        return string?.length < value ? true : false
    }

    static lessThanOrEqualTo(string = "", value = 0){
        return string?.length <= value ? true : false
    }

    static equalTo(string = "", value = 0){
        return string?.length == value ? true : false
    }

}